import { render } from "./HelpMenu.vue?vue&type=template&id=2d4bfe99&scoped=true&bindings={}"
import script from "./HelpMenu.vue?vue&type=script&lang=ts"
export * from "./HelpMenu.vue?vue&type=script&lang=ts"

import "./HelpMenu.vue?vue&type=style&index=0&id=2d4bfe99&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2d4bfe99"

export default script